<template>
  <div class="main-view">
    <div id="widget" ref="widget" class="widget-host"></div>
  </div>
</template>
<script>
let opportunitiesScriptPromise = null;

function loadOpportunitiesScriptOnce() {
  if (opportunitiesScriptPromise) return opportunitiesScriptPromise;

  opportunitiesScriptPromise = new Promise((resolve, reject) => {
    const scriptId = "mobysuite-opportunities-script";
    const existing = document.getElementById(scriptId);

    // Si el script ya existe, asumimos que fue cargado previamente o está cargando.
    // No bloqueamos el render esperando `customElements.define`, porque en producción puede demorarse
    // (o incluso ser bloqueado por CSP) y no queremos impedir que el DOM del widget exista.
    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://cdn.mobysuite.com/opportunities/js/app.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = (e) => reject(e);
    document.head.appendChild(script);
  });

  return opportunitiesScriptPromise;
}

export default {
  name: "opportunities",
  data() {
    return {
      projectId: null,
      showQuote: false,
      quoteWidget: null,
      widgetInitInFlight: false,
    };
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
  },
  watch: {
    gcVersion: {
      handler() {
        this.renderWidget();
      },
      immediate: true,
    },
    customer: {
      handler() {
        this.renderWidget();
      },
      immediate: true,
    },
  },
  mounted() {
    this.renderWidget();
  },
  methods: {
    renderWidget() {
      if (this.widgetInitInFlight) return;

      const widgetEl = this.$refs.widget;
      if (!widgetEl) return;

      // Evita renderizar con defaults mientras customerData aún no llega.
      const customerData = this.$store.getters.getCustomerData;
      if (!customerData || customerData.gc_version == null) return;
      if (!this.customer) return;

      this.widgetInitInFlight = true;
      try {
        // Render del custom element (no bloqueante). El browser lo “upgradeará” cuando el script esté listo.
        widgetEl.innerHTML = `<mobysuite-opportunities customer="${this.customer}" version="${customerData.gc_version}" template="imagina"
        class="my-10"
        no-title="true"
        full-height-photo="true"
        carrousel="true"></mobysuite-opportunities>`;

        // Carga del script una sola vez. Si falla (CSP/404/red), dejamos el log y el tag renderizado.
        loadOpportunitiesScriptOnce().catch((e) => {
          // eslint-disable-next-line no-console
          console.error("[opportunities] Error loading widget script", e);
        });
      } catch (e) {
        // En prod, es útil tener un log explícito si falla la carga del widget.
        // eslint-disable-next-line no-console
        console.error("[opportunities] Error loading widget", e);
      } finally {
        this.widgetInitInFlight = false;
      }
    },
  },
};
</script>

<style scoped>
.main-view {
  background: transparent;
  min-height: 100vh;
  width: 100%;
}

.widget-host {
  min-height: 100vh;
  width: 100%;
}
</style>
